import './DevPanel_TabPanel.scss';

import React from 'react';

import {
  Box,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types';

const DevPanel_TabPanel = ( props ) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={ value !== index }
      id={ `tabpanel-${index}` }
      aria-labelledby={ `tab-${index}` }
      className='DevPanel_TabPanel'
      { ...other }
    >
      { value === index && (
        <Box className='tab-content'>
          <Typography component='pre' variant='body2'>
            { children }
          </Typography>
        </Box>
      ) }
    </div>
  );
};

const propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

DevPanel_TabPanel.propTypes = propTypes;

export default DevPanel_TabPanel;